export default "__VITE_ASSET__Bth9U0mN__"